import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'app-progress-item',
  templateUrl: './progress-item.component.html',
  styleUrls: ['./progress-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressItemComponent implements OnInit {
  @Input() count!: number;
  @Input() routerLink!: string;
  @Input() title!: string;
  @Input() value: number | undefined = 0;
  @Input() checked: boolean = false;
  @Input() invalid: boolean = false;

  constructor() {}

  ngOnInit(): void {}
}
